import React from "react"
import { Icon as MuiIcon, useTheme } from "@material-ui/core"
import {
  AccountCircle,
  DescriptionOutlined,
  PlaylistAddCheckOutlined,
  NotificationsOutlined,
  Search,
  FormatListNumbered,
  PeopleOutline,
  FeedbackOutlined,
  AccessTime,
  Repeat,
  Public,
  Category,
  InfoOutlined,
  Image,
  CloudUpload,
  ListAlt,
  PersonOutline,
  VisibilityOutlined,
  Star,
  AspectRatio,
  Alarm,
  ArrowBack,
  Warning,
  Today,
  Android,
  Apple,
  EditOutlined,
  FileCopyOutlined,
  HelpOutline,
  RestorePageOutlined,
  AssignmentIndOutlined,
  ArrowDownward,
  TabletMacOutlined,
  TabletAndroidOutlined,
  PhoneAndroidOutlined,
  PhoneIphoneOutlined,
  ComputerOutlined,
  DesktopMacOutlined,
  TvOutlined,
  PinDropOutlined,
  Phonelink,
  UpdateOutlined,
  SettingsApplicationsOutlined,
  PhonelinkSetupOutlined,
  BatteryAlert,
  Battery30,
  Battery20,
  Battery50,
  Battery60,
  Battery80,
  Battery90,
  SignalWifi0Bar,
  SignalWifi1Bar,
  SignalWifi2Bar,
  SignalWifi3Bar,
  SignalWifi4Bar,
  Refresh,
  Redo,
  FlagOutlined,
  Undo,
  CameraAltOutlined,
  AddPhotoAlternateOutlined,
  Notes,
  ArrowForward,
  Flag,
  ArrowDropDown,
  SettingsRemoteOutlined,
  AssessmentOutlined,
  BallotOutlined,
  MoreHoriz,
  BatteryFull,
  PictureAsPdfOutlined,
  SchoolOutlined,
  MenuBookOutlined,
  ChevronRight,
  Check,
  ArrowUpward,
  DragIndicator,
  DeleteOutline,
  Remove,
  Close,
  Visibility,
  List,
  CodeOutlined,
  OpenInNewOutlined,
  MailOutline,
  Loop,
  PublishOutlined,
  AttachFile,
  ExpandMore,
  Block,
  LinkOff,
  Room,
  ExtensionOutlined,
  SettingsOutlined,
  Pause,
  SyncAlt,
  MessageOutlined,
  LockOutlined,
  Done,
  StarOutline,
  SendOutlined,
  Schedule,
  Fullscreen,
  FullscreenExit,
  SortByAlpha,
  Sort,
} from "@material-ui/icons"
import { Logo } from ".."

import SvgCommsDark from "./svg/icon-comms-dark.svg"
import SvgCommsLight from "./svg/icon-comms-light.svg"
import SvgHomeDark from "./svg/icon-home-dark.svg"
import SvgHomeLight from "./svg/icon-home-light.svg"
import { ReactComponent as SvgJobsDark } from "./svg/icon-jobs-dark.svg"
import SvgJobsLight from "./svg/icon-jobs-light.svg"
import SvgKnowledgeDark from "./svg/icon-kb-dark.svg"
import SvgKnowledgeLight from "./svg/icon-kb-light.svg"
import SvgPeopleLight from "./svg/icon-people-light.svg"
import SvgSettingsDark from "./svg/icon-settings-dark.svg"
import SvgSettingsLight from "./svg/icon-settings-light.svg"
import SvgTemplatesDark from "./svg/icon-templates-dark.svg"
import SvgTemplatesLight from "./svg/icon-templates-light.svg"
import SvgPin from "./svg/icon-pin.svg"

import SvgEmptyActiveJobs from "./svg/icon-empty-activejobs.svg"
import SvgEmptyActivity from "./svg/icon-empty-activity.svg"
import SvgEmptyAssignedJobs from "./svg/icon-empty-assignedjobs.svg"
import SvgEmptyComms from "./svg/icon-empty-comms.svg"
import SvgEmptyKnowledge from "./svg/icon-empty-kb.svg"
import SvgEmptySearch from "./svg/icon-empty-search.svg"
import SvgEmptyTemplates from "./svg/icon-empty-templates.svg"

import SvgBannersComms from "./svg/icon-ob-comms.svg"
import SvgBannersKnowledge from "./svg/icon-ob-kb.svg"
import SvgBannersPeople from "./svg/icon-ob-people.svg"
import SvgBannersTemplates from "./svg/icon-ob-templates.svg"

import SvgAdhoc from "./svg/icon-adhoc.svg"
import SvgProcess from "./svg/icon-process.svg"
import SvgTask from "./svg/icon-task.svg"

import FacebookLogo from "./png/fb.png"
import GoogleLogo from "./png/google.png"
import MicrosoftLogo from "./png/microsoft.png"

const getClassNameWithMaterialOutlined = (className) => `material-icons-outlined ${className || ""}`.trim()

const Icon = ({ name, customName, ...rest }) => {
  switch (`${name}`.toLowerCase()) {
    case "operandio":
      return <Logo {...rest} />

    case "account-circle":
      return <AccountCircle {...rest} />
    case "group":
    case "integration-group":
      return <PeopleOutline {...rest} />
    case "everyone":
      return <Public {...rest} />
    case "identity-provider":
      return <AssignmentIndOutlined {...rest} />
    case "integration":
      return <ExtensionOutlined {...rest} />
    case "integration-mapping":
      return <SyncAlt {...rest} />
    case "integration-event":
      return (
        <MuiIcon {...rest} className="material-icons-outlined">
          send_time_extension
        </MuiIcon>
      )
    case "integration-location":
      return (
        <MuiIcon {...rest} className="material-icons-outlined">
          where_to_vote
        </MuiIcon>
      )
    case "integration-user":
      return (
        <MuiIcon {...rest} className="material-icons-outlined">
          person_pin
        </MuiIcon>
      )
    case "trigger":
      return <SendOutlined {...rest} />
    case "trigger-scheduled":
      return <Schedule {...rest} />
    case "trigger-event":
      return <SendOutlined {...rest} />
    case "location":
      return <PinDropOutlined {...rest} />
    case "location-pin":
      return <Room {...rest} />
    case "region":
      return (
        <MuiIcon {...rest} className={getClassNameWithMaterialOutlined(rest?.className)}>
          map
        </MuiIcon>
      )
    case "timezone":
      return <Public {...rest} />
    case "clock":
      return <Schedule {...rest} />

    case "settings":
      return <img {...rest} src={SvgSettingsDark} alt="Settings" />
    case "settings-light":
      return <img {...rest} src={SvgSettingsLight} alt="Settings" />
    case "setting":
      return <SettingsApplicationsOutlined {...rest} />
    case "configure":
      return <SettingsOutlined {...rest} />

    case "dashboard":
      return <img {...rest} src={SvgHomeDark} alt="Dashboard" />
    case "dashboard-light":
      return <img {...rest} src={SvgHomeLight} alt="Dashboard" />

    case "jobs":
      return <SvgJobsDark {...rest} aria-label="Jobs" />
    case "jobs-light":
      return <img {...rest} src={SvgJobsLight} alt="Jobs" />

    case "training":
      return <SchoolOutlined {...rest} />
    case "training-module":
      return <MenuBookOutlined {...rest} />
    case "training-module-complete":
    case "accreditations-compliant":
    case "tick":
      return <Check {...rest} />
    case "paused":
      return <Pause {...rest} />
    case "accreditations-awaiting":
      return <PublishOutlined {...rest} />
    case "accreditation":
      return (
        <MuiIcon {...rest} className={getClassNameWithMaterialOutlined(rest?.className)}>
          badge
        </MuiIcon>
      )
    case "accreditation-alt":
      return <AssignmentIndOutlined {...rest} />

    case "adhoc":
      return <img {...rest} src={SvgAdhoc} alt="Adhoc" />
    case "task":
      return <img {...rest} src={SvgTask} alt="Task" />
    case "process":
      return <img {...rest} src={SvgProcess} alt="Process" />
    case "steps":
      return <FormatListNumbered {...rest} />
    case "steps-complete":
      return <PlaylistAddCheckOutlined {...rest} />
    case "form":
      return <ListAlt {...rest} />

    case "knowledge":
      return <img {...rest} src={SvgKnowledgeDark} alt="Knowledge" />
    case "knowledge-light":
      return <img {...rest} src={SvgKnowledgeLight} alt="Knowledge" />

    case "category":
      return <Category {...rest} />

    case "hub":
      return <img {...rest} src={SvgCommsDark} alt="Hub" />
    case "hub-light":
      return <img {...rest} src={SvgCommsLight} alt="Hub" />

    case "calendar":
      return (
        <MuiIcon {...rest} className={getClassNameWithMaterialOutlined(rest?.className)}>
          calendar_month_outlined
        </MuiIcon>
      )
    case "calendar-month":
      return (
        <MuiIcon {...rest} className={getClassNameWithMaterialOutlined(rest?.className)}>
          calendar_view_month
        </MuiIcon>
      )
    case "calendar-week":
      return (
        <MuiIcon {...rest} className={getClassNameWithMaterialOutlined(rest?.className)}>
          calendar_view_week
        </MuiIcon>
      )

    case "person":
      return <PersonOutline {...rest} />
    case "people":
      return <PeopleOutline {...rest} />
    case "people-light":
      return <img {...rest} src={SvgPeopleLight} alt="People" />

    case "sensors":
      return <SettingsRemoteOutlined {...rest} />
    case "sensors-temperature":
      return <MuiIcon {...rest}>device_thermostat</MuiIcon>

    case "templates":
      return <img {...rest} src={SvgTemplatesDark} alt="Templates" />
    case "templates-light":
      return <img {...rest} src={SvgTemplatesLight} alt="Templates" />
    case "templates-menu":
      return <BallotOutlined {...rest} />

    case "reports":
      return <AssessmentOutlined {...rest} />

    case "post":
      return <FeedbackOutlined {...rest} />

    case "repeat":
      return <Repeat {...rest} />

    case "time":
      return <AccessTime {...rest} />
    case "due":
      return <Alarm {...rest} />
    case "date":
      return <Today {...rest} />
    case "no-expiry":
      return <Loop {...rest} />

    case "pinned":
      return <img {...rest} src={SvgPin} style={{ color: "#7f7f7f" }} alt="Pinned" />

    case "skip":
      return <Redo {...rest} />
    case "unskip":
      return <Undo {...rest} />
    case "action":
      return <FlagOutlined {...rest} />
    case "action-raised":
      return <Flag {...rest} />
    case "note":
      return (
        <MuiIcon {...rest} className={getClassNameWithMaterialOutlined(rest?.className)}>
          insert_drive_file
        </MuiIcon>
      )
    case "note-added":
      return <MuiIcon {...rest}>insert_drive_file</MuiIcon>
    case "notes":
      return <MessageOutlined {...rest} />
    case "done":
      return <Done {...rest} />

    case "text":
      return <Notes {...rest} />
    case "number":
      return <MuiIcon {...rest}>numbers</MuiIcon>
    case "camera":
      return <CameraAltOutlined {...rest} />
    case "photo":
      return <AddPhotoAlternateOutlined {...rest} />
    case "rating":
      return <StarOutline {...rest} />

    case "notifications":
      return <NotificationsOutlined {...rest} />
    case "announcement":
      return (
        <MuiIcon {...rest} className={getClassNameWithMaterialOutlined(rest?.className)}>
          new_releases
        </MuiIcon>
      )
    case "search":
      return <Search {...rest} />

    case "information":
      return <InfoOutlined {...rest} />
    case "warning":
      return <Warning {...rest} />
    case "help":
      return <HelpOutline {...rest} />
    case "draft":
      return <RestorePageOutlined {...rest} />
    case "code":
      return <CodeOutlined {...rest} />

    case "image":
      return <Image {...rest} />
    case "document":
      return <DescriptionOutlined {...rest} />
    case "pdf":
      return <PictureAsPdfOutlined {...rest} />
    case "upload":
      return <CloudUpload {...rest} />
    case "attach-file":
      return <AttachFile {...rest} />

    case "custom":
      return <MuiIcon {...rest}>{customName}</MuiIcon>

    case "facebook":
      return <img {...rest} src={FacebookLogo} alt="Facebook" />
    case "google":
      return <img {...rest} src={GoogleLogo} alt="Google" />
    case "microsoft":
      return <img {...rest} src={MicrosoftLogo} alt="Microsoft" />

    case "view":
      return <VisibilityOutlined {...rest} />
    case "view-alt":
      return <Visibility {...rest} />
    case "cancel":
      return <Close {...rest} />
    case "confirm":
      return <Check {...rest} />
    case "back":
      return <ArrowBack {...rest} />
    case "forward":
      return <ArrowForward {...rest} />
    case "up":
      return <ArrowUpward {...rest} />
    case "down":
      return <ArrowDownward {...rest} />
    case "right":
      return <ChevronRight {...rest} />
    case "copy":
      return <FileCopyOutlined {...rest} />
    case "edit":
      return <EditOutlined {...rest} />
    case "download":
      return (
        <MuiIcon {...rest} className={getClassNameWithMaterialOutlined(rest?.className)}>
          file_download
        </MuiIcon>
      )
    case "download-photos":
      return (
        <MuiIcon {...rest} className={getClassNameWithMaterialOutlined(rest?.className)}>
          perm_media
        </MuiIcon>
      )
    case "download-failed":
      return <MuiIcon {...rest}>file_download_off</MuiIcon>
    case "zip":
      return (
        <MuiIcon {...rest} className={getClassNameWithMaterialOutlined(rest?.className)}>
          folder_zip
        </MuiIcon>
      )
    case "drag":
      return <DragIndicator {...rest} />
    case "delete":
    case "remove":
      return <DeleteOutline {...rest} />
    case "delete-failed":
      return <Block {...rest} />
    case "not-found":
      return <LinkOff {...rest} />
    case "none":
      return <Remove {...rest} />
    case "external-link":
      return <OpenInNewOutlined {...rest} />
    case "mail":
    case "email":
      return <MailOutline {...rest} />
    case "message":
      return <MessageOutlined {...rest} />
    case "restricted":
      return <LockOutlined {...rest} />
    case "fullscreen":
      return <Fullscreen {...rest} />
    case "fullscreen-exit":
      return <FullscreenExit {...rest} />
    case "rank":
      return <Sort {...rest} />
    case "sort-by-alpha":
      return <SortByAlpha {...rest} />

    case "expand-down":
      return <ExpandMore {...rest} />

    case "featured-star":
      return <FeaturedStar {...rest} />

    case "display-size":
      return <AspectRatio {...rest} />

    case "android":
      return <Android {...rest} />
    case "android-2":
      return <TabletAndroidOutlined {...rest} />
    case "android-1":
      return <PhoneAndroidOutlined {...rest} />
    case "android-0":
    case "android-3":
      return <ComputerOutlined {...rest} />
    case "android-4":
      return <TvOutlined {...rest} />

    case "ios":
      return <Apple {...rest} />
    case "ios-2":
      return <TabletMacOutlined {...rest} />
    case "ios-1":
      return <PhoneIphoneOutlined {...rest} />
    case "ios-0":
    case "ios-3":
      return <DesktopMacOutlined {...rest} />
    case "ios-4":
      return <TvOutlined {...rest} />

    case "device-registered":
      return <Phonelink {...rest} />
    case "device-managed":
      return <PhonelinkSetupOutlined {...rest} />
    case "last-activity":
      return <UpdateOutlined {...rest} />

    case "empty-activejobs":
      return <img src={SvgEmptyActiveJobs} {...rest} alt="" />
    case "empty-activity":
      return <img src={SvgEmptyActivity} {...rest} alt="" />
    case "empty-assignedjobs":
      return <img src={SvgEmptyAssignedJobs} {...rest} alt="" />
    case "empty-comms":
      return <img src={SvgEmptyComms} {...rest} alt="" />
    case "empty-knowledge":
    case "empty-trainingmodules":
    case "empty-trainingcourses":
    case "training-complete":
      return <img src={SvgEmptyKnowledge} {...rest} alt="" />
    case "empty-search":
      return <img src={SvgEmptySearch} {...rest} alt="" />
    case "empty-templates":
      return <img src={SvgEmptyTemplates} {...rest} alt="" />

    case "banners-comms":
      return <img src={SvgBannersComms} {...rest} alt="" />
    case "banners-knowledge":
      return <img src={SvgBannersKnowledge} {...rest} alt="" />
    case "banners-people":
      return <img src={SvgBannersPeople} {...rest} alt="" />
    case "banners-templates":
      return <img src={SvgBannersTemplates} {...rest} alt="" />

    case "retry":
      return <Refresh {...rest} />
    case "rate-limit":
      return <MuiIcon {...rest}>network_ping</MuiIcon>
    case "offline":
      return <MuiIcon {...rest}>cloud_off</MuiIcon>

    case "battery0":
    case "battery5":
      return <BatteryAlert {...rest} />
    case "battery10":
    case "battery15":
    case "battery20":
    case "battery25":
      return <Battery20 {...rest} />
    case "battery30":
    case "battery35":
      return <Battery30 {...rest} />
    case "battery40":
    case "battery45":
    case "battery50":
    case "battery55":
      return <Battery50 {...rest} />
    case "battery60":
    case "battery65":
    case "battery70":
    case "battery75":
      return <Battery60 {...rest} />
    case "battery80":
    case "battery85":
      return <Battery80 {...rest} />
    case "battery90":
      return <Battery90 {...rest} />
    case "battery95":
      return <BatteryFull {...rest} />

    case "signal0":
      return <SignalWifi0Bar {...rest} />
    case "signal10":
    case "signal20":
    case "signal30":
      return <SignalWifi1Bar {...rest} />
    case "signal40":
    case "signal50":
      return <SignalWifi2Bar {...rest} />
    case "signal60":
    case "signal70":
      return <SignalWifi3Bar {...rest} />
    case "signal80":
    case "signal90":
    case "signal100":
      return <SignalWifi4Bar {...rest} />

    case "submenu":
      return <ArrowDropDown {...rest} />
    case "more":
      return <MoreHoriz {...rest} />
    case "list":
      return <List {...rest} />
    case "list-alt":
      return <ListAlt {...rest} />

    default:
      throw new Error(`Unknown icon: ${name}, please map it in the MaterialIcon component`)
  }
}

const FeaturedStar = ({ ...rest }) => {
  const theme = useTheme()

  return <Star style={{ color: theme.palette.featured.main }} {...rest} />
}

export { Icon }
